module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cash"
    }
  }, [(_vm.have) ? _c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "300"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._l((_vm.prizeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [(item.name.length > 7) ? _c('span', {
      staticClass: "min"
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.create_time))]), _vm._v(" "), _c('span', [(item.exchange_status == 'no') ? _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.getCode(item)
        }
      }
    }, [_vm._v("立即兑换")]) : _c('a', {
      staticClass: "btn disabled"
    }, [_vm._v("已兑换")])])])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMore),
      expression: "noMore"
    }],
    staticClass: "nomore"
  }, [_vm._v("数据加载完成")])], 2) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "codebox"
  }, [_c('p', [_vm._v("兑奖二维码")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.codeImg
    }
  }), _vm._v(" "), _c('p', [_vm._v("兑奖码：" + _vm._s(_vm.qrCode))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('span', [_vm._v("奖品")]), _vm._v(" "), _c('span', [_vm._v("中奖时间")]), _vm._v(" "), _c('span', [_vm._v("兑换")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2efc3ed0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/cash.vue
// module id = 460
// module chunks = 0